import type { ChartSpec } from 'src/types/pages.types'
import { getFunctions, httpsCallable } from 'firebase/functions'

export interface ChatResponse {
  text: string
  chartSpec: ChartSpec
}

/**
 * Envía la consulta de usuario a la Firebase Function 'chartQuery'.
 */
export async function sendQuery(query: string): Promise<ChatResponse> {
  try {

    const functions = getFunctions()
    const chartQuery = httpsCallable<{ query: string }, ChatResponse>(functions, 'chartQuery')

    const { data } = await chartQuery({ query })
    return data 
  } catch (error) {
    console.error('sendQuery error:', error)
    throw error
  }
}
